export const currencyFormatter = (value: number | string) => {
    if (typeof value === "string") {
        value = parseFloat(value);
    }

    return new Intl.NumberFormat("da-DK", {
        style: "currency",
        currency: "DKK",
        minimumFractionDigits: 0,
    }).format(value);
};
